<script>
import ConfigureStamp from '@/febos/global/usuario/components/sign/shared/ConfigureStamp';
export default ConfigureStamp;
</script>
